import { render, staticRenderFns } from "./KommunikationsAdresse.vue?vue&type=template&id=b7310bae"
import script from "./KommunikationsAdresse.vue?vue&type=script&lang=js"
export * from "./KommunikationsAdresse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports